// Dutch (NL) content for SEO category & city pages
export const categoryDataNL = {
  toiture: {
    title: "Offerte Dakwerken",
    description: "Ontvang tot 5 gratis offertes voor uw dakwerken",
    seoTitle: "Offerte Dakwerken België | Renovatie & Herstelling | DevisMaison.be",
    content: {
      intro: "Het dak is het belangrijkste element van uw woning. Een dak in goede staat garandeert optimale bescherming tegen weersinvloeden en een goede thermische isolatie.",
      types: ["Volledige dakrenovatie", "Vervanging van dakpannen of leien", "Dakisolatie", "Herstelling van lekken", "Plaatsing van dakvensters (Velux)", "Zinkwerk en dakgoten"],
      prices: [
        { type: "Volledige dakrenovatie", price: "100-180 €/m²" },
        { type: "Vervanging dakpannen", price: "40-80 €/m²" },
        { type: "Dakisolatie", price: "30-60 €/m²" },
        { type: "Herstelling lekken", price: "150-400 €" }
      ]
    }
  },
  renovation: {
    title: "Offerte Renovatie",
    description: "Ontvang tot 5 gratis offertes voor uw renovatieproject",
    seoTitle: "Offerte Renovatie Woning België | Totaalrenovatie | DevisMaison.be",
    content: {
      intro: "De renovatie van uw woning verhoogt de waarde ervan en verbetert uw dagelijks comfort. Of het nu gaat om een volledige of gedeeltelijke renovatie, onze gekwalificeerde vakmensen staan voor u klaar.",
      types: ["Volledige woningrenovatie", "Appartementsrenovatie", "Woninguitbreiding", "Zolderinrichting", "Energetische renovatie", "Elektrische keuring en conformiteit"],
      prices: [
        { type: "Lichte renovatie", price: "300-600 €/m²" },
        { type: "Gemiddelde renovatie", price: "600-1000 €/m²" },
        { type: "Zware renovatie", price: "1000-1500 €/m²" },
        { type: "Uitbreiding", price: "1500-2500 €/m²" }
      ]
    }
  },
  chassis: {
    title: "Offerte Ramen & Deuren",
    description: "Ontvang tot 5 gratis offertes voor uw ramen en deuren",
    seoTitle: "Offerte Ramen & Deuren België | Dubbele Beglazing | DevisMaison.be",
    content: {
      intro: "Het vervangen van uw ramen verbetert de thermische en akoestische isolatie van uw woning. Kies uit PVC, aluminium of hout volgens uw behoeften.",
      types: ["PVC ramen", "Aluminium ramen", "Houten ramen", "Dubbele beglazing", "Driedubbele beglazing", "Voordeuren"],
      prices: [
        { type: "Standaard PVC raam", price: "400-700 €" },
        { type: "Aluminium raam", price: "600-1000 €" },
        { type: "Raamdeur", price: "800-1500 €" },
        { type: "Voordeur", price: "1500-3000 €" }
      ]
    }
  },
  isolation: {
    title: "Offerte Isolatie",
    description: "Ontvang tot 5 gratis offertes voor de isolatie van uw woning",
    seoTitle: "Offerte Isolatie België | Muren, Dak, Vloeren | DevisMaison.be",
    content: {
      intro: "Een goede isolatie verlaagt uw energiefactuur en verbetert het comfort van uw woning. Profiteer ook van de beschikbare energiepremies in België.",
      types: ["Dakisolatie", "Buitenmuurisolatie", "Binnenmuurisolatie", "Vloerisolatie", "Kelderisolatie", "Akoestische isolatie"],
      prices: [
        { type: "Dakisolatie langs binnen", price: "30-50 €/m²" },
        { type: "Spouwmuurisolatie", price: "20-35 €/m²" },
        { type: "Gevelisolatie (crepi)", price: "100-180 €/m²" },
        { type: "Vloerisolatie", price: "25-45 €/m²" }
      ]
    }
  },
  "salle-de-bain": {
    title: "Offerte Badkamer",
    description: "Ontvang tot 5 gratis offertes voor de renovatie van uw badkamer",
    seoTitle: "Offerte Badkamer België | Volledige Renovatie | DevisMaison.be",
    content: {
      intro: "De badkamer is een essentiële ruimte in uw woning. Een doordachte renovatie verhoogt het comfort en de waarde van uw vastgoed.",
      types: ["Volledige badkamerrenovatie", "Vervanging bad/douche", "Plaatsing inloopdouche", "Wand- en vloertegels", "Sanitair loodgieterswerk", "Badkamermeubel en opbergruimte"],
      prices: [
        { type: "Badkamerrenovatie (4m²)", price: "5000-10000 €" },
        { type: "Inloopdouche", price: "1500-3500 €" },
        { type: "Tegels (plaatsing)", price: "40-80 €/m²" },
        { type: "Badkamermeubel", price: "500-2000 €" }
      ]
    }
  },
  terrasse: {
    title: "Offerte Terras",
    description: "Ontvang tot 5 gratis offertes voor uw terras",
    seoTitle: "Offerte Terras België | Hout, Beton, Tegels | DevisMaison.be",
    content: {
      intro: "Een goed aangelegd terras verlengt uw leefruimte en verhoogt de waarde van uw eigendom. Ontdek de verschillende beschikbare opties.",
      types: ["Houten terras", "Composiet terras", "Betonnen terras", "Betegeld terras", "Terras in natuursteen", "Pergola en inrichting"],
      prices: [
        { type: "Houten terras (incl. plaatsing)", price: "80-150 €/m²" },
        { type: "Composiet terras", price: "100-180 €/m²" },
        { type: "Betonplaat", price: "50-100 €/m²" },
        { type: "Buitentegels", price: "70-120 €/m²" }
      ]
    }
  },
  piscine: {
    title: "Offerte Zwembad",
    description: "Ontvang tot 5 gratis offertes voor uw zwembad",
    seoTitle: "Offerte Zwembad België | Bouw & Renovatie | DevisMaison.be",
    content: {
      intro: "Een privézwembad biedt comfort en plezier en verhoogt de waarde van uw eigendom. Vergelijk de offertes om de oplossing te vinden die bij uw budget past.",
      types: ["Ingegraven betonnen zwembad", "Polyester kuipzwembad", "Bovengronds zwembad", "Renovatie bestaand zwembad", "Uitrusting en accessoires", "Zwembadoverkapping"],
      prices: [
        { type: "Kuipzwembad (8x4m)", price: "20000-35000 €" },
        { type: "Betonnen zwembad (8x4m)", price: "30000-50000 €" },
        { type: "Bovengronds zwembad", price: "3000-15000 €" },
        { type: "Zwembadoverkapping", price: "5000-20000 €" }
      ]
    }
  },
  chauffage: {
    title: "Offerte Verwarming",
    description: "Ontvang tot 5 gratis offertes voor uw verwarmingssysteem",
    seoTitle: "Offerte Verwarming België | Warmtepomp, Ketel | DevisMaison.be",
    content: {
      intro: "Een efficiënt verwarmingssysteem verlaagt uw energiefactuur en verbetert uw comfort. Profiteer van de premies voor het vervangen van uw oude ketel.",
      types: ["Lucht/water warmtepomp", "Lucht/lucht warmtepomp", "Condensatieketel op gas", "Pelletketel", "Vloerverwarming", "Radiatoren"],
      prices: [
        { type: "Warmtepomp", price: "8000-15000 €" },
        { type: "Condensatieketel gas", price: "3000-6000 €" },
        { type: "Pelletketel", price: "10000-18000 €" },
        { type: "Vloerverwarming (renovatie)", price: "50-80 €/m²" }
      ]
    }
  },
  electricite: {
    title: "Offerte Elektriciteit",
    description: "Ontvang tot 5 gratis offertes voor uw elektriciteitswerken",
    seoTitle: "Offerte Elektriciteit België | Installatie & Renovatie | DevisMaison.be",
    content: {
      intro: "Een conforme elektrische installatie is essentieel voor de veiligheid van uw woning. Doe een beroep op gecertificeerde elektriciens voor al uw werken.",
      types: ["Elektrische conformiteit", "Renovatie volledige installatie", "Zekeringkast", "Plaatsing stopcontacten en schakelaars", "Binnen-/buitenverlichting", "Domotica"],
      prices: [
        { type: "Conformiteitswerken", price: "1500-4000 €" },
        { type: "Volledige renovatie (woning)", price: "6000-15000 €" },
        { type: "Zekeringkast", price: "800-2000 €" },
        { type: "Lichtpunt (toevoegen)", price: "100-200 €" }
      ]
    }
  },
  plafonnage: {
    title: "Offerte Pleisterwerk",
    description: "Ontvang tot 5 gratis offertes voor uw pleisterwerken",
    seoTitle: "Offerte Pleisterwerk België | Pleister & Afwerking | DevisMaison.be",
    content: {
      intro: "Pleisterwerk is essentieel voor gladde, schilderklaar muren. Onze professionele stukadoors garanderen een onberispelijke afwerking voor al uw projecten.",
      types: ["Pleisterwerk nieuwe muren", "Renovatie bestaand pleisterwerk", "Decoratieve pleister", "Binnencrepi", "Egaliseren van oppervlakken", "Verlaagde plafonds"],
      prices: [
        { type: "Standaard pleisterwerk", price: "20-35 €/m²" },
        { type: "Decoratieve pleister", price: "40-70 €/m²" },
        { type: "Herstelling scheuren", price: "15-30 €/m²" },
        { type: "Verlaagd plafond", price: "45-80 €/m²" }
      ]
    }
  },
  menuiserie: {
    title: "Offerte Binnenschrijnwerk",
    description: "Ontvang tot 5 gratis offertes voor uw binnenschrijnwerk",
    seoTitle: "Offerte Binnenschrijnwerk België | Deuren & Trappen | DevisMaison.be",
    content: {
      intro: "Binnenschrijnwerk geeft karakter en functionaliteit aan uw interieur. Deuren, trappen, kasten op maat - onze schrijnwerkers creëren oplossingen op maat van uw behoeften.",
      types: ["Binnendeuren", "Trappen op maat", "Kasten en dressings", "Parket en plankenvloer", "Plinten en lijstwerk", "Ingebouwde boekenkasten"],
      prices: [
        { type: "Binnendeur (plaatsing)", price: "250-600 €" },
        { type: "Trap op maat", price: "3000-10000 €" },
        { type: "Kast op maat", price: "800-3000 €" },
        { type: "Parket (plaatsing)", price: "35-70 €/m²" }
      ]
    }
  },
  "amenagement-exterieur": {
    title: "Offerte Tuinaanleg",
    description: "Ontvang tot 5 gratis offertes voor de aanleg van uw buitenruimte",
    seoTitle: "Offerte Tuinaanleg België | Tuin & Opritten | DevisMaison.be",
    content: {
      intro: "Een mooie buitenaanleg verhoogt de waarde van uw eigendom en creëert aangename leefruimtes. Tuinen, opritten, omheiningen - transformeer uw buitenruimte met gekwalificeerde professionals.",
      types: ["Tuinaanleg", "Opritten en bestrating", "Omheiningen en poorten", "Buitenverlichting", "Keermuren", "Tuinhuizen"],
      prices: [
        { type: "Bestrate oprit", price: "60-120 €/m²" },
        { type: "Standaard omheining", price: "80-150 €/meter" },
        { type: "Automatische poort", price: "2000-5000 €" },
        { type: "Tuinhuis", price: "1500-8000 €" }
      ]
    }
  },
  "entreprise-generale": {
    title: "Offerte Algemene Aanneming",
    description: "Ontvang tot 5 gratis offertes voor uw bouwwerken",
    seoTitle: "Offerte Algemene Aannemer België | Bouw & Ruwbouw | DevisMaison.be",
    content: {
      intro: "Een algemene aannemer coördineert al uw bouw- of renovatiewerken. Eén aanspreekpunt voor alle vakgebieden, wat het beheer van uw project vereenvoudigt.",
      types: ["Nieuwbouw", "Totaalrenovatie", "Ruwbouw", "Woninguitbreiding", "Verbouwing van gebouwen", "Werfcoördinatie"],
      prices: [
        { type: "Nieuwbouw", price: "1500-2500 €/m²" },
        { type: "Totaalrenovatie", price: "800-1500 €/m²" },
        { type: "Uitbreiding", price: "1800-3000 €/m²" },
        { type: "Enkel ruwbouw", price: "600-1000 €/m²" }
      ]
    }
  },
  carrelage: {
    title: "Offerte Tegelwerk",
    description: "Ontvang tot 5 gratis offertes voor uw tegelwerken",
    seoTitle: "Offerte Tegelwerk België | Vloer & Muur | DevisMaison.be",
    content: {
      intro: "Tegels zorgen voor duurzaamheid en esthetiek op uw vloeren en muren. Onze professionele tegelzetters realiseren een verzorgde plaatsing voor alle soorten tegels.",
      types: ["Binnenvloertegels", "Wandtegels", "Faience badkamer", "Terrastegels", "Decoratief mozaïek", "Renovatie tegelwerk"],
      prices: [
        { type: "Vloertegels (plaatsing)", price: "35-60 €/m²" },
        { type: "Wandtegels", price: "40-70 €/m²" },
        { type: "Grootformaat tegels", price: "50-90 €/m²" },
        { type: "Mozaïek", price: "80-150 €/m²" }
      ]
    }
  },
  cuisine: {
    title: "Offerte Keuken",
    description: "Ontvang tot 5 gratis offertes voor uw keukenproject",
    seoTitle: "Offerte Keuken België | Inrichting & Renovatie | DevisMaison.be",
    content: {
      intro: "De keuken is het hart van uw woning. Of u nu een volledige renovatie of een eenvoudige opfrissing wenst, onze professionele keukenbouwers creëren de ruimte van uw dromen.",
      types: ["Volledige keuken op maat", "Renovatie bestaande keuken", "Vervanging werkblad", "Installatie huishoudtoestellen", "Keukeneiland", "Inrichting kleine keuken"],
      prices: [
        { type: "Instapkeuken", price: "3 000-6 000 €" },
        { type: "Middenklasse keuken", price: "6 000-15 000 €" },
        { type: "Luxekeuken", price: "15 000-30 000 €" },
        { type: "Keuken op maat", price: "20 000-50 000 €" }
      ]
    }
  },
  "extension-maison": {
    title: "Offerte Aanbouw",
    description: "Ontvang tot 5 gratis offertes voor de uitbreiding van uw woning",
    seoTitle: "Offerte Aanbouw België | Woninguitbreiding | DevisMaison.be",
    content: {
      intro: "Vergroot uw leefruimte zonder te verhuizen. Een aanbouw vergroot de bewoonbare oppervlakte en de waarde van uw vastgoed.",
      types: ["Zijdelingse aanbouw", "Optopping van het dak", "Bewoonbare veranda", "Vrijstaande bijbouw", "Zolderinrichting", "Aanbouw in houtskelet"],
      prices: [
        { type: "Klassieke aanbouw", price: "1 500-2 500 €/m²" },
        { type: "Optopping", price: "1 800-3 000 €/m²" },
        { type: "Veranda", price: "1 000-2 000 €/m²" },
        { type: "Houtskeletbouw", price: "1 200-2 200 €/m²" }
      ]
    }
  },
  "pompe-a-chaleur": {
    title: "Offerte Warmtepomp",
    description: "Ontvang tot 5 gratis offertes voor de installatie van een warmtepomp",
    seoTitle: "Offerte Warmtepomp België | Installatie | DevisMaison.be",
    content: {
      intro: "De warmtepomp is dé ecologische en zuinige verwarmingsoplossing bij uitstek. Verlaag uw energiefactuur en uw ecologische voetafdruk.",
      types: ["Lucht-water warmtepomp", "Lucht-lucht warmtepomp", "Geothermische warmtepomp", "Thermodynamische boiler", "Vervanging ketel door warmtepomp", "Onderhoud warmtepomp"],
      prices: [
        { type: "Lucht-water warmtepomp", price: "8 000-15 000 €" },
        { type: "Lucht-lucht warmtepomp", price: "3 000-8 000 €" },
        { type: "Geothermische warmtepomp", price: "15 000-25 000 €" },
        { type: "Thermodynamische boiler", price: "2 500-4 500 €" }
      ]
    }
  },
  climatisation: {
    title: "Offerte Airco",
    description: "Ontvang tot 5 gratis offertes voor de installatie van airco",
    seoTitle: "Offerte Airco België | Installatie & Onderhoud | DevisMaison.be",
    content: {
      intro: "Geniet het hele jaar door van optimaal comfort met een aangepaste airco. Onze gecertificeerde installateurs adviseren u de beste oplossing voor uw woning.",
      types: ["Muur split airco", "Multi-split airco", "Kanaalairco", "Reversibele airco", "Kantoorairco", "Onderhoud en herstelling"],
      prices: [
        { type: "Muur split (1 unit)", price: "1 500-3 000 €" },
        { type: "Multi-split (2-4 units)", price: "3 500-8 000 €" },
        { type: "Kanaalairco", price: "5 000-12 000 €" },
        { type: "Jaarlijks onderhoud", price: "100-200 €" }
      ]
    }
  },
  plomberie: {
    title: "Offerte Loodgieterij",
    description: "Ontvang tot 5 gratis offertes voor uw loodgieterswerken",
    seoTitle: "Offerte Loodgieter België | Installatie & Herstelling | DevisMaison.be",
    content: {
      intro: "Loodgieterswerken uitgevoerd door gekwalificeerde professionals. Van een eenvoudige herstelling tot de volledige installatie van uw sanitair netwerk.",
      types: ["Volledige sanitaire installatie", "Herstelling van lekken", "Vervanging leidingen", "Installatie boiler", "Ontstopping leidingen", "Aansluiting toestellen"],
      prices: [
        { type: "Herstelling lek", price: "80-250 €" },
        { type: "Installatie boiler", price: "500-2 000 €" },
        { type: "Volledige renovatie loodgieterij", price: "3 000-8 000 €" },
        { type: "Ontstopping", price: "100-300 €" }
      ]
    }
  },
  facade: {
    title: "Offerte Gevelwerken",
    description: "Ontvang tot 5 gratis offertes voor de renovatie van uw gevel",
    seoTitle: "Offerte Gevelwerken België | Renovatie & Isolatie | DevisMaison.be",
    content: {
      intro: "De gevel is de eerste indruk van uw woning. Een gevelrenovatie beschermt uw woning en geeft ze haar volle glans terug.",
      types: ["Gevelrenovatie", "Buitengevelisolatie", "Crepi en pleister", "Hogedrukreiniging", "Hervoegen van bakstenen", "Gevelschilderwerk"],
      prices: [
        { type: "Eenvoudige gevelrenovatie", price: "30-60 €/m²" },
        { type: "Buitenisolatie", price: "100-180 €/m²" },
        { type: "Decoratieve crepi", price: "40-80 €/m²" },
        { type: "Hervoegen", price: "25-50 €/m²" }
      ]
    }
  },
  parquet: {
    title: "Offerte Parket",
    description: "Ontvang tot 5 gratis offertes voor uw parketwerken",
    seoTitle: "Offerte Parket België | Plaatsing & Renovatie | DevisMaison.be",
    content: {
      intro: "Parket brengt warmte en elegantie in uw interieur. Onze parketexperts begeleiden u van de selectie tot de plaatsing of renovatie.",
      types: ["Plaatsing massief parket", "Plaatsing samengesteld parket", "Plaatsing laminaat", "Schuren en vernissen", "Herstelling oud parket", "Parket geschikt voor vloerverwarming"],
      prices: [
        { type: "Massief parket (geleverd en geplaatst)", price: "60-120 €/m²" },
        { type: "Samengesteld parket", price: "40-80 €/m²" },
        { type: "Laminaat", price: "20-45 €/m²" },
        { type: "Schuren + vernissen", price: "25-40 €/m²" }
      ]
    }
  },
  peinture: {
    title: "Offerte Schilderwerken",
    description: "Ontvang tot 5 gratis offertes voor uw schilderwerken",
    seoTitle: "Offerte Schilderwerken België | Binnen & Buiten | DevisMaison.be",
    content: {
      intro: "Professioneel schilderwerk transformeert uw ruimtes. Onze gekwalificeerde schilders zorgen voor een onberispelijke afwerking van uw muren, plafonds en houtwerk.",
      types: ["Binnenschilderwerk muren", "Schilderen plafonds", "Buitenschilderwerk", "Decoratief schilderwerk", "Lakken van houtwerk", "Voorbereiding en plamuren"],
      prices: [
        { type: "Muren schilderen (per kamer)", price: "200-600 €" },
        { type: "Plafond schilderen", price: "15-30 €/m²" },
        { type: "Buitenschilderwerk", price: "20-40 €/m²" },
        { type: "Deuren lakken", price: "100-200 €/deur" }
      ]
    }
  }
};

export const cityInfoNL = {
  Bruxelles: { region: "Brussels Hoofdstedelijk Gewest", description: "Brussel, de hoofdstad van België, biedt een dynamische markt voor renovatie- en bouwwerken." },
  Namur: { region: "Wallonië", description: "Namen, de hoofdstad van Wallonië, combineert historisch erfgoed en moderniteit voor uw renovatieprojecten." },
  Luxembourg: { region: "Groothertogdom", description: "De stad Luxemburg, hoofdstad van het Groothertogdom, biedt een premium markt voor bouwwerken." },
  "Liège": { region: "Wallonië", description: "Luik, de derde stad van België, is een belangrijk economisch centrum met talrijke renovatieprojecten." },
  Charleroi: { region: "Henegouwen", description: "Charleroi, een stad in volle transformatie, kent een stedelijke heropleving met talrijke renovatie- en bouwprojecten." },
  Arlon: { region: "Luxemburg (BE)", description: "Aarlen, de hoofdplaats van de provincie Luxemburg, ligt ideaal aan de grens met het Groothertogdom voor uw grensoverschrijdende projecten." },
  "Marche-en-Famenne": { region: "Luxemburg (BE)", description: "In het hart van de Famenne is Marche-en-Famenne een dynamische stad omgeven door natuur, ideaal voor duurzame bouwprojecten." },
  Bastogne: { region: "Luxemburg (BE)", description: "Bastenaken, een historische stad in de Ardennen, combineert erfgoed en moderniteit met talrijke residentiële renovatieprojecten." },
  "Luxembourg-province": { region: "Luxemburg (BE)", description: "De provincie Luxemburg, de grootste provincie van België, biedt een uitzonderlijk natuurlijk kader voor uw bouwprojecten." },
  Mons: { region: "Henegouwen", description: "Bergen, culturele hoofdstad, verleidt met zijn architecturaal erfgoed en talrijke stadsvernieuwingsprojecten." },
  Nivelles: { region: "Waals-Brabant", description: "In het hart van Waals-Brabant geniet Nijvel van een dynamische vastgoedmarkt en talrijke bouwprojecten." },
  "Luxembourg-Ville": { region: "Groothertogdom", description: "Luxemburg-Stad, Europese hoofdstad, biedt een premium markt met een sterke vraag naar hoogwaardige renovatie en bouw." },
  "Esch-sur-Alzette": { region: "Groothertogdom", description: "Esch-sur-Alzette, de tweede stad van het Groothertogdom, kent een belangrijke stedelijke ontwikkeling met talrijke werven." },
  Differdange: { region: "Groothertogdom", description: "Differdange, de derde stad van Luxemburg, moderniseert zich met ambitieuze residentiële en commerciële projecten." }
};
